'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = require('fbjs/lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return (0, _invariant2.default)(false, '`getScreenConfig` has been replaced with `getScreenOptions`');
};


//////////////////
// WEBPACK FOOTER
// ./~/react-navigation/lib/routers/getScreenConfigDeprecated.js
// module id = 21
// module chunks = 0